import { nanoid } from 'nanoid';

export const projectData = {
  desktopProjects: [
    {
      id: nanoid(),
      imagePath: 'GraphicEQ.png',
      containerWidth: '570px',
      type: 'desktop',
      title: 'Graphic EQ',
      language: 'C++',
      stack: 'JUCE',
      features: [
        'Based on the classic Klark-Teknik DN360',
        'Frequency spectrum analyzer',
        'Mono or Stereo operation',
        'VST, AAX, & AudioUnit compatible',
      ],
      info: "31-Band Audio Plugin Equalizer",
      internalUrl: '', // if no internalUrl, the button will not show up
      externalUrl: '', // if no externalUrl, the button will not show up
      repo: '', // if no repo, the button will not show up
    },
    {
      id: nanoid(),
      imagePath: 'PandemicPokerClub-Table.png',
      containerWidth: '570px',
      type: 'desktop',
      title: 'Pandemic Poker Club',
      language: 'C++',
      stack: 'Qt',
      features: [
        'Play on Windows, Mac OSX, or Linux',
        'Up to 9 players per table',
        'Built-in chat',
        'SVG card graphics'
      ],
      info: "Cross-Platform Texas Hold 'Em Server & Client",
      internalUrl: '', // if no internalUrl, the button will not show up
      externalUrl: '', // if no externalUrl, the button will not show up
      repo: '', // if no repo, the button will not show up
    },
    {
      id: nanoid(),
      imagePath: 'CryptoTradingBot.png',
      containerWidth: '570px',
      type: 'desktop',
      title: 'Cryptocurrency Trading Bot',
      language: 'C++',
      stack: 'Qt',
      features: [
        'Trade on Windows, Mac OSX, or Linux',
        'Coinbase, Binance.US, & Bybit support, with more on the way',
        'Full real-time order books',
        'Websocket price data and REST API orders'
      ],
      info: 'Websocket-Powered Arbitrage Trading & Alerts',
      internalUrl: '', // if no internalUrl, the button will not show up
      externalUrl: '', // if no externalUrl, the button will not show up
      repo: '', // if no repo, the button will not show up
    }
  ],

  mobileProjects: [
    {
      id: nanoid(),
      imagePath: 'BaseballTop10.png',
      containerWidth: '220px',
      type: 'mobile',
      title: 'Baseball Top 10',
      language: 'Dart',
      stack: 'Flutter, SQLite',
      features: [
        'Search the Lahman Baseball Database for batting, pitching, and fielding statistics back to 1871.',
        'Save your favorite Top (and Bottom) lists in persistent storage.',
        'No internet connection needed.'
      ],
      info: 'MLB History at Your Fingertips',
      internalUrl: '', // if no internalUrl, the button will not show up
      externalUrl: '', // if no externalUrl, the button will not show up
      repo: '', // if no repo, the button will not show up
    },
    {
      id: nanoid(),
      imagePath: 'TheoSimulator.png',
      containerWidth: '220px',
      type: 'mobile',
      title: 'Theo Simulator',
      language: 'Dart',
      stack: 'Flutter',
      features: [],
      info: 'Just like the real thing!',
      internalUrl: '', // if no internalUrl, the button will not show up
      externalUrl: '', // if no externalUrl, the button will not show up
      repo: 'https://github.com/Nightlights524/theo_simulator_flutter', // if no repo, the button will not show up
    },
  ],

  webProjects: [
    // {
    //   id: nanoid(),
    //   imagePath: 'Rupert.png',
    //   containerWidth: '767px',
    //   type: 'web',
    //   title: 'PomDEX.io',
    //   language: 'JavaScript, HTML, CSS',
    //   stack: 'React',
    //   features: [
    //     'Spot Trading, Automated Market Maker Swaps, & Liquidity Pools',
    //     'Hardware and software wallet support',
    //   ],
    //   info: 'Decentralized Exchange for the Stellar Blockchain',
    //   internalUrl: '', // if no internalUrl, the button will not show up
    //   externalUrl: 'https://www.pomdex.io', // if no externalUrl, the button will not show up
    //   repo: '', // if no repo, the button will not show up
    // },
    {
      id: nanoid(),
      imagePath: 'Rupert.png',
      containerWidth: '767px',
      type: 'web',
      title: 'Rupert',
      language: 'JavaScript, Solidity, HTML, CSS',
      stack: 'Truffle, Ganache, Web3, React, Node',
      features: [
        'Runs on Ethereum, Binance Smart Chain, or any Ethereum-compatible blockchain',
        'Hardware wallet support through Metamask',
        'Requires Metamask installation and connection to the "Ropsten" test network',
      ],
      info: 'Ethereum Store Demo, ERC-20 Token, & Smart Contract',
      internalUrl: '/rupert/', // if no internalUrl, the button will not show up
      externalUrl: '', // if no externalUrl, the button will not show up
      repo: 'https://github.com/Nightlights524/rupert-demo', // if no repo, the button will not show up
    },
    {
      id: nanoid(),
      imagePath: 'NightlightSoftware.png',
      containerWidth: '480px',
      type: 'web',
      title: 'This Website',
      language: 'JavaScript, HTML, CSS',
      stack: 'Gatsby, React, Google Cloud Functions, GraphQL, Serverless',
      features: [],
      info: 'Personal Portfolio',
      internalUrl: '', // if no internalUrl, the button will not show up
      externalUrl: '', // if no externalUrl, the button will not show up
      repo: '', // if no repo, the button will not show up
    },
    {
      id: nanoid(),
      imagePath: 'DrumMachine.png',
      containerWidth: '500px',
      type: 'web',
      title: 'Drum Machine',
      language: 'JavaScript, HTML, CSS',
      stack: 'React',
      features: [],
      info: "Makin' hits!",
      internalUrl: '/drum-machine/', // if no internalUrl, the button will not show up
      externalUrl: '', // if no externalUrl, the button will not show up
      repo: 'https://github.com/Nightlights524/drum-machine', // if no repo, the button will not show up
    },
    {
      id: nanoid(),
      imagePath: 'ChoroplethMap.png',
      containerWidth: '380px',
      type: 'web',
      title: 'Choropleth Map',
      language: 'JavaScript, HTML, CSS',
      stack: 'D3',
      features: [],
      info: 'Data Visualization Example with D3',
      internalUrl: '/choropleth-map/', // if no internalUrl, the button will not show up
      externalUrl: '', // if no externalUrl, the button will not show up
      repo: 'https://github.com/Nightlights524/d3-choropleth-map-react', // if no repo, the button will not show up
    },
    // {
    //   id: nanoid(),
    //   imagePath: 'gatsby-astronaut.png',
    //   containerWidth: '300px',
    //   type: 'web',
    //   title: 'Personal Library',
    //   language: 'JavaScript, HTML, CSS',
    //   stack: 'MongoDB, Express, React, Node',
    //   features: [],
    //   info: 'This is a really cool Web App!',
    //   internalUrl: '', // if no internalUrl, the button will not show up
    //   externalUrl: '', // if no externalUrl, the button will not show up
    //   repo: '', // if no repo, the button will not show up
    // },
    // {
    //   id: nanoid(),
    //   imagePath: 'gatsby-astronaut.png',
    //   containerWidth: '300px',
    //   type: 'web',
    //   title: 'Exercise Tracker',
    //   language: 'JavaScript, HTML, CSS',
    //   stack: 'MongoDB, Express, React, Node',
    //   features: [],
    //   info: 'Microservice Example',
    //   internalUrl: '', // if no internalUrl, the button will not show up
    //   externalUrl: '', // if no externalUrl, the button will not show up
    //   repo: '', // if no repo, the button will not show up
    // },
    {
      id: nanoid(),
      imagePath: 'JavaScriptCalculator.png',
      containerWidth: '230px',
      type: 'web',
      title: 'JavaScript Calculator',
      language: 'JavaScript, HTML, CSS',
      stack: 'React',
      features: [],
      info: 'You know you need it!',
      internalUrl: '/javascript-calculator/', // if no internalUrl, the button will not show up
      externalUrl: '', // if no externalUrl, the button will not show up
      repo: 'https://github.com/Nightlights524/javascript-calculator', // if no repo, the button will not show up
    },
    {
      id: nanoid(),
      imagePath: 'PomodoroClock.png',
      containerWidth: '230px',
      type: 'web',
      title: 'Pomodoro Clock',
      language: 'JavaScript, HTML, CSS',
      stack: 'React',
      features: [],
      info: 'Increase your productivity!',
      internalUrl: '/pomodoro-clock/', // if no internalUrl, the button will not show up
      externalUrl: '', // if no externalUrl, the button will not show up
      repo: 'https://github.com/Nightlights524/25-5-clock', // if no repo, the button will not show up
    },
  ]
};